import { stateKeys } from '../constants/stateKeys';

export const selectShowLightbox = (state) => state[stateKeys.showLightbox];

export const selectImages = (state) => state[stateKeys.images];

export const selectImageIndexes = (state) => state[stateKeys.imageIndexes];

export const selectSelectedImageIndex = (state) =>
  state[stateKeys.selectedImageIndex];
